function generateLoanBalances(loanDetails = []) {
  const res = {};

  for (const loan of loanDetails) {
    if (loan.success) {
      const { ixReqBalSrc, bal } = loan.data[loan.data.length - 1];
      res[ixReqBalSrc] = bal;
    }
  }

  return res;
}

export default generateLoanBalances;
